// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__25X7s"};